<style lang="stylus">
@import '../../common/stylus/mixin.styl'
.news
    padding-top:30px
    .new_card
        padding: 25px 60px
        .title
            height: 50px
            line-height: 35px
            color: #90a8b7
            font-size: 14px
            border-bottom: 1px solid #c2d2dc
            .title_text
                float left
                width 70px
                border-bottom: 2px solid $basecolor
                text-align center
                color:#fff
                background:rgba(39,81,203,1);
                border-radius:10px;
            .select_all, .select_no, .del
                float left
                margin-left 15px
                .select_btn
                    width:70px
                    text-align:center
                    border:1px solid rgba(39,81,203,1);
                    border-radius:10px;
                    color:rgba(39,81,203,1);
                    cursor:pointer;
        .newsList-wrapper
            .newsList
                border-radius: 3px
                font-size: 14px
                .newsItem
                    display block
                    box-sizing: border-box
                    position: relative
                    height 65px
                    line-height 65px
                    border-bottom: 1px solid #ebebeb
                    color: #5a5a5a
                    .ivu-checkbox-checked .ivu-checkbox-inner
                        border-color:#2751CB
                        background:#2751CB
                    &:last-child
                        border: none
                    .time
                        float: right
                        color: #92a8b5
                        font-size 12px
                    a
                        color: #5a5a5a
                    .text
                        a
                            display inline-block
                            max-width 570px
                            overflow: hidden
                            text-overflow: ellipsis
                            white-space: nowrap
                            vertical-align top
                            color: #2751CB
                    .ivu-badge
                        margin 0 20px 0 10px
                        .ivu-avatar
                            background-color transparent
                            img
                                border-radius: 50%
            .no_data
                margin-left: 40px
</style>

<template>
<div class="news appwrap topMargin">
    <Card class="new_card" :padding="0" :bordered="false">
        <div class="title clearfix">
            <div class="title_text">所有消息</div>
            <div class="select_all"><div class="select_btn" @click="selectAll">全选</div></div>
            <div class="select_no"><div class="select_btn"  @click="selectNo">取消选择</div></div>
            <!-- <div class="select_all"><Button size="small" type="ghost" @click="selectAll">全选</Button></div> -->
            <!-- <div class="select_no"><Button size="small" type="ghost" @click="selectNo">取消选择</Button></div> -->
            <div class="del"><Button type="error" :disabled="!selectedNids.length" @click="del">删除</Button></div>
        </div>
        <div class="newsList-wrapper">
            <ul class="newsList">
                <li class="newsItem" v-for="(notif,index) in notifs" :key="index">
                    <span class="time">{{notif.time}}</span>

                    <Checkbox v-model="notif.isSelected"></Checkbox>
                    <Badge v-if="notif.type == nType.company_normal || notif.type == nType.company_normal_del || notif.type == nType.choose_lawyer || notif.type == nType.replaced_lawyer || notif.type == nType.renew_choose_lawyer  || notif.type == nType.renew_choose_lawyer || notif.type === nType.company_account_dredge || notif.type === nType.company_account_remove || notif.type === nType.add_serve_lawyer||notif.type === nType.del_serve_lawyer||notif.type === nType.latent_com_change || !notif.detail.f" :dot="!notif.is_readed && !isReadNotifs">
                        <Avatar src="/static/img/logo2.png" shape="square" />
                    </Badge>
                    <Badge v-else :dot="!notif.is_readed && !isReadNotifs">
                        <span @click="toPersonalCenter(notif.detail.f)" style="cursor: pointer">
                            <Avatar :src="$avatarHash(notif.detail.f)" shape="square" />
                        </span>
                    </Badge>

                    <span v-if="notif.detail.f_n" class="name">
                        <a v-if="notif.type == nType.company_normal || notif.type == nType.company_normal_del || notif.type == nType.choose_lawyer || notif.type == nType.replaced_lawyer || notif.type == nType.renew_choose_lawyer || notif.type == nType.renew_choose_lawyer || notif.type === nType.company_account_dredge|| notif.type === nType.company_account_remove||notif.type === nType.add_serve_lawyer||notif.type === nType.del_serve_lawyer|| notif.type === nType.latent_com_change">{{notif.detail.f_n}}</a>
                        <a v-else href="javascript:;" @click="toPersonalCenter(notif.detail.f)">{{notif.detail.f_n}}</a>
                    </span>
                    <!--消息类型-->
                    <span class="text" v-if="notif.type === nType.auth_edit">授予你在<a href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》{{notif.detail.num > 1 ? '等多篇知识' : ''}}</a>中的编辑权限</span>

                    <span class="text" v-if="notif.type === nType.auth_view">授予你在<a href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》{{notif.detail.num > 1 ? '等多篇知识' : ''}}</a>中的阅读权限</span>

                    <span class="text" v-if="notif.type === nType.user_follow" >关注了你</span>

                    <span class="text" v-if="notif.type === nType.post_comment">评论了你的知识<a href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

                    <span class="text" v-if="notif.type === nType.comment_comment">回复了你在<a href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a>中的评论</span>

                    <span class="text" v-if="notif.type === nType.post_upvote">点赞了你的知识<a href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

                    <span class="text" v-if="notif.type === nType.keep_comment">回复了你的案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}}&gt;案件进展</span>

                    <span class="text" v-if="notif.type === nType.case_create">创建了团队案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

                    <span class="text" v-if="notif.type === nType.keep_add">在你的案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}} 中新增了案件进展</span>

                    <span class="text" v-if="notif.type === nType.keep_update">在你的案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}}&gt;案件进展 中更新了附件</span>

                    <span class="text" v-if="notif.type === nType.flow_comment">评论了你的案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}}</span>

                    <span class="text" v-if="isLawyer && notif.type === nType.case_comment">回复了你对业务<a class="content_link" href="javascript:;" @click="toBusinessList(notif.detail.a)">《{{notif.detail.a_n.case}}》</a>的评论</span>

                    <span class="text" v-if="!isLawyer && notif.type === nType.case_comment">回复了你发布的业务<a class="content_link" href="javascript:;" @click="toSelectLawyer(notif.detail.a)">《{{notif.detail.a_n.case}}》</a></span>

                    <span class="text" v-if="notif.type === nType.coactor">授予你成为案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a>的协作者</span>

                    <span class="text" v-if="notif.type === nType.visitor">授予你案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a>的查看权限</span>

                    <span class="text" v-if="notif.type === nType.contact">授予你成为案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a>的联系人</span>

                    <span class="text" v-if="notif.type === nType.lawyer_designate">选择你成为案件<a href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a>的办理律师</span>

                    <span class="text" v-if="notif.type === nType.join_team">已将你添加为团队成员</span>

                    <!-- 审核的消息 -->
                    <span class="text" v-if="notif.type === nType.admin_auth && notif.detail.result">{{notif.detail.reason}}</span>
                    <span class="text" v-if="notif.type === nType.admin_auth && !notif.detail.result">{{notif.detail.reason}}。请重新去 <a class="content_link" href="javascript:;" @click="toConfirm">认证</a> ！</span>

                    <span class="text" v-if="notif.type === nType.enterprise_audit && notif.detail.result">{{notif.detail.reason}}</span>
                    <span class="text" v-if="notif.type === nType.enterprise_audit && !notif.detail.result">{{notif.detail.reason}}</span>

                    <span class="text" v-if="notif.type === nType.order_audit && notif.detail.result">{{notif.detail.reason}}</span>
                    <span class="text" v-if="notif.type === nType.order_audit && !notif.detail.result">{{notif.detail.reason}}</span>

                    <span class="text" v-if="notif.type === nType.enterprise_audit_change && notif.detail.result">{{notif.detail.reason}}</span>
                    <span class="text" v-if="notif.type === nType.enterprise_audit_change && !notif.detail.result">{{notif.detail.reason}}</span>

                    <span class="text" v-if="notif.type === nType.enterprise_audit_change_admin && notif.detail.result">{{notif.detail.reason}}</span>
                    <span class="text" v-if="notif.type === nType.enterprise_audit_change_admin && !notif.detail.result">{{notif.detail.reason}}</span>

                    <!-- 日程添加 -->
                    <span class="text" v-if="notif.type === nType.schedure_add">将你添加为日程<a href="javascript:;" @click="$store.commit('showSchPanel')">《{{notif.detail.a_n}}》</a>的成员，日程的开始时间为{{notif.detail.s_t | getDate}}</span>

                    <span class="text" v-if="notif.type === nType.expire_remind">您的账号 {{notif.detail.a_n}}，请及时<a href="javascript:;" @click="gotoOrderMange">续费</a></span>

                    <span class="text" v-if="notif.type === nType.user_evaluate">{{notif.detail.f_n ? '' : '匿名用户 '}}评价了您，去<a href="javascript:;" @click="toPersonalCenter($store.state.mineInfo.id)">个人中心</a>查看</span>

                    <!-- 案件流程跟进@ -->
                    <span class="text" v-if="notif.type === nType.flow_caseRecord">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.c_id, notif.detail.f_id)">《{{notif.detail.c_name}}》</a>的流程《{{notif.detail.f_name || '未命名流程'}}》的跟进：{{notif.detail.a_n}} 中@了你</span>

                    <!-- 流程推送 -->
                    <span class="text" v-if="notif.type === nType.flow_push">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)">《{{notif.detail.a_n.case}}》</a>中给你推送了流程 {{notif.detail.a_n.flow || '未命名流程'}}</span>

                    <!-- 流程授权 -->
                    <span class="text" v-if="notif.type === nType.flow_auth_edit">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.flow_id)">《{{notif.detail.a_n.case}}》</a>中给你授权了流程 {{notif.detail.a_n.flow || '未命名流程'}} 的编辑权限</span>

                    <!-- 推送附件通知 -->
                    <span class="text" v-if="notif.type === nType.file_push">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)">《{{notif.detail.a_n.case}}》</a>中的流程 {{notif.detail.a_n.flow || '未命名流程'}} 给你推送了附件 {{notif.detail.a_n.file}}</span>

                    <span class="text" v-if="notif.type === nType.dissolve_team">解散了团队</span>
                    <span class="text" v-if="notif.type === nType.kickout_team">把你移出了团队</span>
                    <span class="text" v-if="notif.type === nType.quit_team">退出了团队</span>

                    <span class="text" v-if="notif.type === nType.client_coactor">将您添加为案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的协作者</span>

                    <!-- 2018.7.27 新增通知 -->
                    <span class="text" v-if="notif.type === nType.company_admin">您成为<a class="content_link" href="javascript:;" @click="toCompany"> {{notif.detail.a_n}} </a>公司的管理员</span>

                    <span class="text" v-if="notif.type === nType.normal_create_case">添加了案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n}}》 </a></span>

                    <span class="text" v-if="notif.type === nType.lawyer_create_company_case">律师给您创建了新的案件</span>

                    <span class="text" v-if="notif.type === nType.normal_del_case">删除了案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n}}》 </a>，删除的案件将存到您的最近删除列表</span>

                    <span class="text" v-if="notif.type === nType.normal_create_flow">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n.case}}》 </a>中新增了流程</span>

                    <span class="text" v-if="notif.type === nType.normal_del_flow">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)"> 《{{notif.detail.a_n.case}}》 </a>中删除了流程 {{notif.detail.a_n.flow || '未命名流程'}}</span>

                    <span class="text" v-if="notif.type === nType.service_expire">请到已购服务列表查看</span>

                    <span class="text" v-if="notif.type === nType.service_affirm">律师向您发起了<a class="content_link" href="javascript:;" @click="toCompanyService"> {{notif.detail.a_n}} </a>确认完成请求，请到对应的服务项下面处理</span>

                    <span class="text" v-if="notif.type === nType.choose_lawyer">选择您为该公司的法律顾问</span>

                    <span class="text" v-if="notif.type === nType.replaced_lawyer">解除了与您的合作关系，请双方遵守《服务协议》</span>

                    <span class="text" v-if="notif.type === nType.renew_choose_lawyer">选择您为该公司的法律顾问，开始服务时间为：{{notif.detail.r_t}}</span>

                    <span class="text" v-if="notif.type === nType.company_create_case">给您发布了新的案件 <a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)"> 《{{notif.detail.a_n}}》 </a></span>

                    <span class="text" v-if="notif.type === nType.refuse_service_affirm">您发起的 {{notif.detail.a_n}} 确认服务请求被拒绝，请与客户沟通；</span>

                    <span class="text" v-if="notif.type === nType.agree_service_affirm">您发起的 {{notif.detail.a_n}} 确认服务请求已确认完成</span>

                    <span class="text" v-if="notif.type === nType.company_normal">添加您为该公司的法务人员</span>

                    <span class="text" v-if="notif.type === nType.company_normal_del">将您请离该公司的企业服务号</span>

                    <span class="text" v-if="notif.type === nType.latent_com_push">给您推送了新客户<a href="javascript:;" @click="customerDetails(notif)">{{notif.detail.a_n}}</a></span>

                    <!-- 未测试 -->
                    <span class="text" v-if="notif.type === nType.latent_com_change">取消了您与客户<a  class="content_link" href="javascript:;">{{notif.detail.a_n}}</a>的合作关系</span>
                    
                    <span class="text" v-if="notif.type === nType.add_honsen_role" >将您添加为弘商的{{notif.detail.r}}</span>

                    <span class="text" v-if="notif.type === nType.del_honsen_role">取消您的{{notif.detail.r }}身份</span>

                    <span class="text" v-if="notif.type === nType.add_company_salesman" >授予您对企业客户 <a class="content_link" href="javascript:;" @click="goAdminList(notif.detail.a)">《{{notif.detail.a_n}}》</a> 编辑权限</span>

                    <span class="text" v-if="notif.type === nType.del_company_salesman">取消您对客户 《{{notif.detail.a_n}}》 编辑权限</span>

                    <span class="text" v-if="notif.type === nType.add_serve_lawyer">：恭喜您成为弘商的合作企业服务律师</span>

                    <span class="text" v-if="notif.type === nType.del_serve_lawyer">：您已不是弘商的合作企业律师了</span>

                    <span class="text" v-if="notif.type === nType.company_account_dredge">为您开通了企业服务号</span>
                    
                    <span class="text" v-if="notif.type === nType.company_account_remove">将您从企业服务号中删除</span>
                                
                    <!-- 2019.02.22 -->
                    <span class="text" v-if="notif.type === nType.customer_coactor">授予您为客户《{{notif.detail.a_n}}》的案件协作者</span>

                    <span class="text" v-if="notif.type === nType.customer_visitor">授予您客户《{{notif.detail.a_n}}》的案件查看权限</span>
                    
                    <span class="text" v-if="notif.type === nType.add_lawyerClient_cooperation">授予您对律师客户<a class="content_link" href="javascript:;" @click="goAdminLawyer(notif.detail.a)">《{{notif.detail.a_n}}》 </a>编辑权限</span>
                    <span class="text" v-if="notif.type === nType.del_lawyerClient_cooperation">取消您对律师客户 《{{notif.detail.a_n}}》 编辑权限</span>

                    <!-- 2019.6.26，邀请律师加入咨询会话 -->
                    <span class="text" v-if="notif.type === nType.invite_lawyer">您有一个咨询会话邀请 <a class="content_link" href="javascript:;" @click="toLawyerChat(notif)">  点击进入  </a></span>

                    <!-- 2020,8,31,台账劳动合同到期提示 -->
                    <span class="text" v-if="notif.type === nType.standing_book"><a class="content_link" href="javascript:;" @click="goStandBook(notif.detail.a)">{{notif.detail.a_n.name}}的劳动合同要到期了</a></span>

                    <!-- 2020,9,24,知识的阅读，编辑权限的取消 -->
                    <span class="text" v-if="notif.type === nType.cancel_auth_editor"><span v-if="notif.detail.post_num == 1">取消了你在《{{notif.detail.a_n}}》知识的编辑权限</span><span v-else>取消了对你知识的编辑权限</span></span>
                    <span class="text" v-if="notif.type === nType.cancel_auth_viewer"><span v-if="notif.detail.post_num == 1">取消了你在《{{notif.detail.a_n}}》知识的阅读权限</span><span v-else>取消了对你知识的阅读权限</span></span>

                    <!-- 2020,11,11,企业客户合同到期提示 -->
                    <span class="text" v-if="notif.type === nType.customers_sign_date">
                      <span v-if="isCompany &&  isCompany == notif.detail.cid">您的企业法务合同 <span v-if="notif.detail.date_diff >= 0">即将到期</span><span v-else>已到期</span></span>
                      <span v-else><a class="content_link" href="javascript:;" @click="customerDetails(2,notif)">{{notif.detail.name}}</a>的企业法务合同<span v-if="notif.detail.date_diff >= 0">即将到期</span><span v-else>已到期</span></span> 
                    </span>
                    <!-- 2020.12.8.退休提示 -->
                    <span class="text" v-if="notif.type === nType.employee_retire">
                      <span>员工 {{notif.detail.a_n.name}}  快到法定退休年龄了</span>
                    </span>
                    <!-- 2021.1.8种子用户相关信息 -->
                    <span class="text" v-if="notif.type === nType.set_seeds_user">
                      <span>{{notif.detail.a_n}}</span>
                    </span>
                    <!-- 2021.3.9法律专栏付费成功 -->
                    <span class="text" v-if="notif.type === nType.law_article_pay_success">
                      <span v-if="notif.detail.is_author == 0">您支付的商事法律专栏知识<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}}  </a> 已付费成功！</span>
                      <span v-else>已支付您的商事法律专栏<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}} </a></span>
                    </span>
                    <!-- 2021.3.9法律专栏付费失败 -->
                    <span class="text" v-if="notif.type === nType.law_article_pay_fail">
                      <span v-if="notif.detail.is_author == 0">您支付的商事法律专栏知识<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}}  </a> 支付失败！</span>
                    </span>

                </li >
                <infinite-loading @infinite="onInfinite" ref="infiniteLoading" style="margin-top:25px;">
                    <span slot="no-more">没有更多消息了！</span>
                    <span slot="no-results">没有消息！</span>
                </infinite-loading>
            </ul>
        </div>
    </Card>
</div>
</template>

<script>
import moment from 'moment';
import InfiniteLoading from 'vue-infinite-loading';
export default {
    name: 'news',
    components: {InfiniteLoading},
    data() {
        return {
            notifs: [],
            take: 15, // 一次加载数
             /*消息类型(与后端字段一致)*/
            nType: {
                auth_edit: 'auth_edit',
                auth_view: 'auth_view',
                user_follow: 'user_follow',
                post_comment: 'post_comment',
                comment_comment: 'comment_comment',
                post_upvote: 'post_upvote',
                keep_comment: 'keep_comment',
                keep_add: 'keep_add',
                keep_update: 'keep_update',
                flow_comment: 'flow_comment',
                coactor: 'coactor',
                visitor: 'visitor',
                contact: 'contact',
                admin_auth: 'admin_auth',   // 律师认证审核消息通知
                enterprise_audit: 'enterprise_audit', // 企业开通审核消息通知'
                order_audit: 'order_audit',  // 银行转账支付确认消息通知
                enterprise_audit_change: 'enterprise_audit_change',  // 企业信息变更审核消息通知
                enterprise_audit_change_admin: 'enterprise_audit_change_admin',  // 企业管理员变更审核消息通知
                schedure_add: 'schedure_add',
                lawyer_designate: 'lawyer_designate',
                join_team: 'join_team',
                case_comment: 'case_comment',  // 没接收的业务案件
                case_create: 'case_create',
                expire_remind: 'expire_remind',
                user_evaluate: 'user_evaluate',
                flow_caseRecord: 'flow_caseRecord',
                flow_push: 'flow_push',
                flow_auth_edit: 'flow_auth_edit',
                file_push: 'file_push',
                dissolve_team: 'dissolve_team',
                quit_team: 'quit_team',
                kickout_team: 'kickout_team',
                client_coactor: 'client_coactor',

                // 2018.7.27 新增通知
                company_admin: 'company_admin',
                normal_create_case: 'normal_create_case',
                lawyer_create_company_case: 'lawyer_create_company_case',
                normal_del_case: 'normal_del_case',
                normal_create_flow: 'normal_create_flow',
                normal_del_flow: 'normal_del_flow',
                service_expire: 'service_expire',
                service_affirm: 'service_affirm',
                choose_lawyer: 'choose_lawyer',
                replaced_lawyer: 'replaced_lawyer',
                renew_choose_lawyer: 'renew_choose_lawyer',
                company_create_case: 'company_create_case',
                refuse_service_affirm: 'refuse_service_affirm',
                agree_service_affirm: 'agree_service_affirm',
                company_normal: 'company_normal',
                company_normal_del: 'company_normal_del',

                // 2018.12.25 新增通知
                latent_com_push: 'latent_com_push', // 将潜在企业客户第一次推送给律师时通知
                latent_com_change: 'latent_com_change', // 潜在企业客户更换律师时给被更换律师通知
                add_honsen_role: 'add_honsen_role', // 将用户添加到弘商角色中
                del_honsen_role: 'del_honsen_role', // 将用户从弘商角色中剔除
                add_company_salesman: 'add_company_salesman', // 对潜在企业客户授权业务员时通知
                del_company_salesman: 'del_company_salesman', // 对潜在企业客户删除业务员时通知
                add_serve_lawyer: 'add_serve_lawyer', // 添加服务律师给律师通知
                del_serve_lawyer: 'del_serve_lawyer', // 删除服务律师给律师通知
                company_account_dredge: 'company_account_dredge', // 选择企业联系人时给添加的人通知
                company_account_remove: 'company_account_remove', // 选择企业联系人时给被删除的人通知

                // 2019.02.22
                customer_coactor: 'customer_coactor', // 添加客户协作者时通知
                
                // 2019.03.26 新增 客户列表添加外访者
                customer_visitor: 'customer_visitor',
                // 2019.04.10 新增律师客户管理模块通知消息
                add_lawyerClient_cooperation: 'add_lawyerClient_cooperation',
                del_lawyerClient_cooperation: 'del_lawyerClient_cooperation',

                // 2019.06.26 咨询模块，律师加入会话
                invite_lawyer: 'invite_lawyer',
                //2020,8,31 台账劳动合同到期提示
                standing_book:'standing_book',
                //2020,9,24 取消编辑权限
                cancel_auth_editor:'cancel_auth_editor',
                //2020,9,24 取消阅读权限
                cancel_auth_viewer:'cancel_auth_viewer',
                //2020,11,11 企业客户合同到期提示
                customers_sign_date:'customers_sign_date', 
                //2020.12.8退休提示
                employee_retire:'employee_retire',
                //2021.1.8种子用户消息提示
                set_seeds_user:'set_seeds_user',
                //2021.3.9法律专栏付费成功通知
                law_article_pay_success:'law_article_pay_success',
                //2021.3.9法律专栏付费失败通知
                law_article_pay_fail:'law_article_pay_fail'
            },
        }
    },
    computed: {
        isLawyer() {
            return this.$store.getters.auth_code_2 > 10? true: false;
        },
        isCompany(){
          return this.$store.state.mineInfo.have_company;
        },
        isReadNotifs() {
            return this.$store.state.readNotifs;
        },
        currentNotif() {
            return this.$store.state.notifData;
        },
        selectedNids() {
            return this.notifs.filter(val => val.isSelected).map(item => item.nid) || [];
        }
    },
    watch: {
        currentNotif: function(newval,oldval){
            let val = window.JSON.parse(window.JSON.stringify(newval));

            // 反馈
            if (val.type == 'user_feedback' || val.type == 'steward_feedbackReply' || val.type != 'logout') {
                return;
            }

            val.is_readed = 0;
            val.time = moment().format('YYYY-MM-DD HH:mm:ss');
            val.isSelected = false;
            this.notifs.unshift(val);
        }
    },
    methods: {
        //跳转续费
        gotoOrderMange(){
          this.$gotoLawyer('orderManagement');
        },
        //律师加入咨询会话，并跳转页面
        toLawyerChat(item){
            let url='consultcenter/lawyerjoin';
            let params = {
                client_id:item.detail.a
            }
            this.$ajax('post' , url , params, res => {
                if (res.retcode === 0) {
                    this.$message({
                        type: 'success',
                        message: '成功!'
                    });
                    let details = this.$router.resolve({
                        name: "lawyerChat",
                    });
                    window.open(details.href, "_blank")
                } else {
                  this.$message.error(res.data.errmsg)
                }
            })
        },
        selectAll() {
            this.notifs.map(val => {
                val.isSelected = true;
                return val;
            });
        },
        selectNo() {
            this.notifs.map(val => {
                val.isSelected = false;
                return val;
            });
        },
        del() {
            this.$Modal.confirm({
                title: '确认框',
                content: '确定删除吗？',
                onOk: () => {
                    let URL = `/notification/delnotification`;
                    this.$http.post(URL, {nids: this.selectedNids}).then(response => {
                        let data = response.data;
                        if (data.retcode === RETCODE_OK) {
                            this.notifs = this.notifs.filter(val => !this.selectedNids.includes(val.nid));
                            this.$Message.success('删除成功！');

                            if (this.notifs.length < this.take) {
                                this.$nextTick(() => {
                                    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
                                });
                            }

                        }else {
                            this.$Message.error(data.errmsg);
                        }
                    }).catch(err => {});
                },
            })
        },
        toConfirm() {
            if(this.$store.getters.auth_code_3 == 1){
                this.$Message.success('你的账号已经认证!')
            }else{
                // this.$router.push({name: 'identitySet'});
                this.$gotoLawyer('identitySet');
            }
        },
        toCompany() {
            // this.$gotov2('/companyadmin/legal/legalcenter');
        },
        //挑战到台账
        goStandBook(){
          this.$gotoCompany('contractManage');
        },
        toCompanyService() {
            // this.$gotov2('/companyadmin/manage/legalservice');
        },
        toCaseEdit(id) {
            if(this.isCompany){
                this.$gotoCompany('caseEdit/' + id);
            }else{
                this.$ajax('get', `/biz/case/info/${id}`, (data) => {
                    this.$gotoLawyer('caseEdit/' + id);
                });
            }
        },
        //跳转商事法律专栏详情页
        toLawArticle(item){
          this.$router.push({name: 'lawColumnInfo', params: {law_id: parseInt(item.detail.a)}});
        },
        toPersonalCenter(id) {
            if( !id ){
                return false;
            }
            this.$router.push({name: 'personalCenter', params: {id: id}})
        },
        toBusinessList(id) {
            // this.$router.push({ name: 'businessList', query: { personalcaseid: id}});
        },
        toSelectLawyer(id) {
            // this.$router.push({ name: 'selectLawyer', params: { id: id}});
        },
        toPostDetail(id) {
            this.$router.push({name: 'post', params: {post_id: parseInt(id)}});
        },
        onInfinite($state){
            let URL = `/notification/notification?skip=${this.notifs.length}&take=${this.take}`;
            this.$http.get(URL).then((response) => {
                // 请求成功回调
                let data = response.data;
                if (data.retcode === RETCODE_OK) {

                    data.data.forEach(val => {
                        val.isSelected = false;
                    });

                    // 去掉反馈的通知
                    let arr = data.data.filter(val => val.type != 'user_feedback' && val.type != 'steward_feedbackReply' && val.type != 'logout');

                    arr.forEach(e => {
                        if( e.type == 'service_affirm' && typeof e.detail.f_n == 'number' ){
                            this.$ajax('get', `/userinfo/detail/${e.detail.f_n}`, (data2) => {
                                e.detail.f_n = data2.data.name;
                            });
                        }
                    });

                    this.notifs.push(...arr);

                    if (data.data.length < this.take) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }
                }else {
                    this.$Message.error(data.errmsg);
                }
            }).catch(err => {})
        },
		customerDetails(type,item) {
		  if(type == 1){
			  this.$gotoLawyer(`customerDetails/${item.detail.a}`)
		  }else{
			  this.$gotoLawyer(`customerDetails/${item.detail.ctmid}`)
		  }
		},
        goAdminList(lcid) {
            // this.$gotov2(`/admin/list?lcid=${lcid}`)
        },
        goAdminLawyer(lawid) {
            // this.$gotov2(`/admin/lawyerData?lawid=${lawid}`)
        }
    },
    filters: {
        getDate(time) {
            return moment(time).format('YYYY/MM/DD');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/notice/news.vue